export default __webpack_public_path__ + "static/media/nvsir.8ac1cb10.png";